// @mui
import { Box, Stack, useTheme } from "@compass/core";
import { Logo } from "components";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { useMediaQuery } from "@mui/material";

export const AppTopBarBrand = () => {
  const theme = useTheme();
  const appTenantName = useSelector((state: RootState) => state.app.tenantName);
  const showLogoWord = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Stack direction="row" spacing="md" alignItems="center">
          <Logo height="45px" animate={true} alt="Compass Logo" />

      {showLogoWord && (
        <Stack position="relative" color={theme.palette.primary.main} top="2px" pl={2.5}>
          <Box fontSize={"1.3rem"} fontWeight={theme.typography.fontWeightRegular} lineHeight="90%">
            Compass
          </Box>
          <Box fontSize={"0.9rem"} fontWeight={theme.typography.fontWeightRegular} pl="1px">
            {appTenantName}
          </Box>
        </Stack>
      )}
    </Stack>
  );
};
